import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Row, Col} from 'reactstrap';
import './RemoveActiveConsentModal.css';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../../../reducers/common/localization";
import moment from "moment";

class RemoveActiveConsentModal extends Component {
    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.onCancelHandle}>
                <ModalBody>
                    <Row className='remove-active-consent-alert-row'>
                        <Col>{_.get(this.props.translation, 'consents.remove_modal_alert')}</Col>
                    </Row>
                    {this.renderConsentData()}
                    <div className="modal-buttons-container">
                        <Button color="secondary"
                                onClick={this.onCancelHandle}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                        <Button className="olive-green-btn"
                                onClick={this.onRemoveHandle}>{_.get(this.props.translation, "consents.remove_consent_button")}</Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    renderConsentData = () => {
        let paramsList = [
            {
                title: _.get(this.props.translation, 'consents.person_label'),
                value: !_.isNil(this.props.data.firstName) && !_.isNil(this.props.data.lastName) ? this.props.data.firstName + ' ' + this.props.data.lastName : null
            },
            {
                title: _.get(this.props.translation, sharedLabelsPath.company_label),
                value: this.props.data.companyName,
            },
            {
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                value: this.props.data.country
            },
            {
                title: _.get(this.props.translation, sharedLabelsPath.email_label),
                value: this.props.data.email
            },
            {
                title: _.get(this.props.translation, 'consents.valid_till_label'),
                value: _.isNil(this.props.data.expireDate) ? _.get(this.props.translation, 'consents.periods.forever_label') : moment(this.props.data.expireDate).format('LL')
            }
        ];

        return [..._.map(paramsList, this.renderConsentDataRow)]
    };

    renderConsentDataRow = (params) => {
        if (_.isNil(params.value)) {
            return null;
        }

        return (
            <Row className='remove-active-consent-data-row' key={params.title}>
                <Col sm={6}>{params.title}</Col>
                <Col sm={6}>{params.value}</Col>
            </Row>
        );
    };

    onRemoveHandle = () => {
        if (!_.isNil(this.props.data)) {
            this.props.onRemove();
        }
    };

    onCancelHandle = () => {
        this.props.onCancel();
    }
}

RemoveActiveConsentModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    data: PropTypes.object,
    translation: PropTypes.object,
    onRemove: PropTypes.func,
    onCancel: PropTypes.func
};

export default RemoveActiveConsentModal;



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/activeConsentsList/removeActiveConsentModal/RemoveActiveConsentModal.js